// removed by extract-text-webpack-plugin
module.exports = {"notif-transition-enter":"t9s4UUHrxSj9-jzWiALRf","notif-transition-enter-active":"_2fmtPcs-B4aujTIgNqNVSR","notif-transition-leave":"_1BUmrvlXAOY3r1ceiq57cR","notif-transition-leave-active":"OSmBwN15BzpVt30_lmDOV","notif":"_3XFJZCCr70kIhnugJSA3vf","notif--success":"_1s4GLsy6HGEL2LaHT2y-FZ","notif--info":"_1zE5T8G7XwQRcn8SwNejFO","notif--warning":"_1CxIW1DQDr_XqfaTXUi3R5","notif--danger":"DVwKV9kirX6UBg_rq1BEV","notif__container":"_123CxS0fpDSYyQsV0JuQFm"};


//////////////////
// WEBPACK FOOTER
// ../~/redux-notifications/css/styles.css
// module id = 570
// module chunks = 0